const btnTop = document.querySelector('.btn__top');
if(btnTop){
    window.addEventListener('scroll',showBtnTop);
    const scrollCurent = window.scrollY;
    function showBtnTop(){
        if(window.scrollY > 300){
            btnTop.classList.add('show');
            
        }else{
            btnTop.classList.remove('show');
        }
    }}